import styled from "styled-components";
interface IProps {
  color?: string;
  isActive?: boolean;
  pillShape?: boolean;
  roundedRect?: boolean;
  heightWidth?: string;
  padding?: string;
  borderRadius?: string;
  active?: boolean;
  cursor?: string;
}

export const HalfContainer = styled.div`
  width: 50%;
`;
export const SelectedColorButton = styled.div<IProps>`
  height: ${(props) => props.heightWidth || "40px"};
  min-width: ${(props) => props.heightWidth || "40px"};
  padding: ${(props) => props.padding || "5px"};
  border: 2px solid ${(props) => (props.active ? "#57ac2d" : "#cccccc")};
  border-radius: ${(props) => props.borderRadius || "4px"};
  cursor: ${(props) => props.cursor || "pointer"};
  text-align: center;
  line-height: 28px;
  div {
    height: 100%;
    width: 100%;
    background-color: ${(props) => props.color};
    border-radius: ${(props) => props.borderRadius || "4px"};
    cursor: pointer;
  }
  img {
    height: 100%;
    width: 100%;
  }
  &.opaque-unselected {
    opacity: ${(props) => (props.active ? "1" : "0.65")};
    cursor: not-allowed;
  }
  &.opaque-selected {
    opacity: ${(props) => (props.active ? "1" : "0.65")};
    cursor: pointer;
  }
  &.colored-btn-as-input {
    height: auto;
    min-height: 40px;
    max-width: 140px;
    > div {
      min-height: 28px;
      height: auto;
      cursor: pointer;
    }
  }
  &.opaque-btn-as-input {
    height: auto;
    min-height: 40px;
    max-width: 140px;
    > div {
      min-height: 28px;
      height: auto;
      cursor: not-allowed;
    }
  }
`;
export const ButtonStyleSelector = styled.div<IProps>`
  height: 20px;
  width: 35px;
  background: ${(props) => (props.isActive ? "#57AC2D" : "#d9d9d9")};
  border-radius: ${(props) =>
    props.pillShape ? "25px" : props.roundedRect ? "5px" : "0px"};
  cursor: pointer;
`;

export const DescriptionCell = styled.div`
  flex: 1 1 0;

  @media (max-width: 1300px) {
    &.price-field-ss .styled-chkbox label {
      font-size: 14px;
    }
  }
`;
export const MediaBoxesWrapper = styled.div`
  .item-frame-wrapper {
    max-width: 600px;
  }
`;
